module.exports = __webpack_public_path__ + "img/logo.696aae50.png";